module.exports = __webpack_public_path__ + "media/customizations/wolfranchlife/logo-754745bfc1c9bd9a5413e1e74a52d4fa.png";